import { httpClient_get, httpClient_post } from "../../helpers/api";

const getAllConfigurationService = (moduleAffectationId) => {
  return httpClient_get(
    `/moderator/getconfigurations?module_affectation_id=${moduleAffectationId}`
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const createConfigurationService = ({
  moduleAffectationId,
  moduleInstanceName,
}) => {
  return httpClient_post(`/moderator/addmoduleinstance`, {
    moduleAffectationId,
    moduleInstanceName,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const deleteConfigurationService = (moduleInstanceId) => {
  return httpClient_post(
    `/moderator/deletemoduleinstance?module_instance_id=${moduleInstanceId}`,
    null
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const editConfigurationService = ({ moduleInstanceId, moduleInstanceName }) => {
  return httpClient_post(
    `/moderator/updatemoduleinstance?module_instance_id=${moduleInstanceId}&module_instance_name=${moduleInstanceName}`,
    null
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const duplicateConfigurationService = ({
  moduleInstanceId,
  moduleInstanceName,
  notions,
  quizzes,
  games,
}) => {
  return httpClient_post(
    `/moderator/duplicatemoduleinstance?module_instance_id=${moduleInstanceId}&module_instance_name=${moduleInstanceName}&with_notions=${notions}&withQuizzes=${quizzes}&withBusinessGame=${games}`,
    null
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export {
  getAllConfigurationService,
  createConfigurationService,
  deleteConfigurationService,
  editConfigurationService,
  duplicateConfigurationService,
};
